module.exports = __webpack_public_path__ + "img/sidebar-icon-dayoff.8d058012.svg";